// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"2f8c8411","905":"8dc01e21"}[chunkId] + ".chunk.js";
};